import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as techApi from '../../lib/api/tech';

const [
  LIST_TECH_FILES,
  LIST_TECH_FILES_SUCCESS,
  LIST_TECH_FILES_FAILURE,
] = createRequestActionTypes('tech/LIST_TECH_FILES');

export const listTechFiles = createAction(
  LIST_TECH_FILES,
  (fileTyp, fileAttrVal1) => ({ fileTyp, fileAttrVal1 }),
);
const listTechFilesSaga = createRequestSaga(
  LIST_TECH_FILES,
  techApi.getTechFiles
);

const UNLOAD_TECH_FILES = 'tech/UNLOAD_TECH_FILES';
export const unloadTechFiles = createAction(UNLOAD_TECH_FILES);

export function* techFilesSaga() {
  yield takeLatest(LIST_TECH_FILES, listTechFilesSaga);
}

const initialState = {
  files: null,
  error: null,
};

const techFiles = handleActions(
  {
    [LIST_TECH_FILES_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      files: data.list.map((file) => ({
        id: file.fileUuid,
        fileUrl: file.fileUrl,
        fileTyp: file.fileTyp,
        fileAttrVal1: file.fileAttrVal1, //reqUuid
        fileAttrVal2: file.fileAttrVal2, //prjUuid
        fileAttrVal3: file.fileAttrVal3, //기술지원타입(요청,예정,완료)
        fileNm: file.fileNm,
        fileDesc: file.fileDesc,
        crtNm: file.crtNm,
        crtDt: file.crtDt,
        cngNm: file.cngNm,
        cngDt: file.cngDt,
      })),
      error: null,
    }),
    [LIST_TECH_FILES_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_TECH_FILES]: () => initialState,
  },
  initialState,
);

export default techFiles;
